export default {"src":"/_next/static/media/instant-booking.891436d1.svg","height":102,"width":114,"blurWidth":0,"blurHeight":0};